module.exports = __webpack_public_path__ + "static/in-1b12ca65d39c5da4cd6a70872818c302.png";